import {Component, OnDestroy, OnInit, Input, ViewChild, AfterViewInit, OnChanges, SimpleChanges} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NzModalService } from 'ng-zorro-antd/modal';
import { ValidateService } from 'src/app/modules/product/services/validate.service';
import { MasterDataProductService } from 'src/app/modules/product/services/master-data-product.service';
import { ProductService } from '../../product.service';
import { DataService } from '../../services/data.service';
import { ToastrService } from 'ngx-toastr';
import { EventManager } from 'src/app/core';
import { Constant } from 'src/app/core/constant';
import { Fee } from '../../models/fee.model';
import { FeeTransferComponent } from '../fee-transfer/fee-transfer.component';
import { EditComponent } from '../../../../shared/components/edit.component';
import { Product } from '../../models/product.model';
declare let $: any;
@Component({
  selector: 'app-new-transfer-fee-fund',
  templateUrl: './new-transfer-fee-fund.component.html',
  styleUrls: ['./new-transfer-fee-fund.component.scss'],
  providers: [ValidateService, DataService],
})
export class NewTransferFeeFundComponent extends EditComponent implements OnInit, OnChanges, OnDestroy {
  @Input() product: any;
  @Input() startDate: any;
  @Input() fees: any[] = [];
  @Input() currentFees: any[] = [];
  @Input()  relationalOperators: any[] = [];;
  @ViewChild(FeeTransferComponent, { static: true }) feeTransferComponent: FeeTransferComponent;
  id: number;
  sipId: number;
  Constant = Constant;
  programType: any;
  isSIP: boolean = false;
  isChangeDateTransferFee: boolean = false;
  sourcePrograms: any[] = [{id: 1, name: 'Linh Hoạt', code: 'NORMAL'}, { id: 2, name: 'Định kỳ', code: 'SIP'}];
  constructor(
      public router: Router,
      public route: ActivatedRoute,
      public productService: ProductService,
      public dataService: DataService,
      public masterDataProductService: MasterDataProductService,
      public toastrService: ToastrService,
      public validateService: ValidateService,
      public eventManager: EventManager,
      public modalService: NzModalService
  ) {
    super(eventManager, route);
  }
  ngOnInit() {
    const data = this.route.snapshot.data;
    this.isSIP = data.isSip;
    if (data.isSip) {
      this.programType = this.sourcePrograms[1];
    } else {
      this.programType = this.sourcePrograms[0];
    }

    super.ngOnInit();
    this.subscriptions = [
      this.eventManager.subscribe('get-transfer-list' , (res) => {
        this.getTransferList(res.content);
      }),
    ];
  }
  ngOnChanges(changes: SimpleChanges) {
    if (changes.fees && changes.fees.currentValue) {
      this.feeTransferComponent.setTransferList(changes.fees.currentValue);
    }
    if (changes.startDate) {
      this.isChangeDateTransferFee = !changes.startDate.currentValue;
    }
  }
  ngOnDestroy() {
    this.eventManager.destroys(this.subscriptions);
  }
  getTransferList(data) {
    const list = this.fees.filter((fee) => {
      return fee.destProductId == data.destProductId;
    });
    this.feeTransferComponent.setTransferList(list);
  }
  getBefore() {
    this.feeTransferComponent.getTransferFeeList();
  }
  disabledButton() {
    this.feeTransferComponent.getData();
    this.errors.feeTransferComponent = this.feeTransferComponent.disabledButton();
    this.errors.startDate = !this.startDate;
    if (this.errors.startDate) {
      this.toastrService.error('Ngày áp dụng không đúng!');
    }
    this.errors.fees = this.fees.some(item => item.fee === undefined || (item.beginValue === 0 && item.endValue === null));
    return super.disabledButton();
  }
  checkDelete() {
  }
  save() {
    this.isSaved = true;
    if (this.disabledButton()) {
      return;
    }
    const data: any = this.feeTransferComponent.save();
    if (!data) {
      return; 
    }
    const body: any = {
      "clientApiKey": "LOCAL",
      "typeCode": "TRANSFER",
      "productId": this.id,
      "destProductId": data.destProductId,
      "destSchemeId": 1,
      "schemeId": this.programType.id,
      "programId": data.programId,
      "feeUnitCode": data.productFeeInDtoList[0].feeUnitCode,
      "applyAt": this.startDate,
      "details": data.productFeeInDtoList
    }
    return this.productService.createProductFeeTemp(body)
    .subscribe((res: any) => {
      data.productFeeInDtoList.forEach((item) => {
        item.destProductId = data.destProductId;
      })  
      this.fees = [
        ...this.fees.filter((item, index) => {
          return item.destProductId !== data.destProductId;
        }),
        ...data.productFeeInDtoList
      ];
      this.toastrService.success('Lưu phí mới thành công!');
    });
  }
  delete() {
    const data: any = this.feeTransferComponent.save();
    if (!data) {
      return;
    }
    const body: any = {
      "clientApiKey": "LOCAL",
      "typeCode": "TRANSFER",
      productId: this.id,
      schemeId: this.programType.id,
      "destProductId": data.destProductId,
      "destSchemeId": 1,
    }
    return this.productService.deleteProductFeeTemp(body)
    .subscribe((res: any) => {
      this.feeTransferComponent.clearFee();
      this.fees = this.fees.filter((item, index) => {
        return item.destProductId !== data.destProductId;
      });
      this.toastrService.success('Xóa phí mới thành công!');
      if (!this.fees.length) {
        this.startDate = null;
        this.isChangeDateTransferFee = true;
      }
    });
  }
}
